import { createSlice } from "@reduxjs/toolkit";
import { getWaitListByMerchantId } from "../../apis";
import { isTimeInBzHours } from "../../utils";
import { showAlert } from "./feedback";

export const waitlistInitState = {
  list: [],
  history: [],
  edit: {
    waitingNumber: "",
    value: {},
  },
  disabled: false,
};

export const waitlistSlice = createSlice({
  name: "waitlist",
  initialState: { ...waitlistInitState },
  reducers: {
    setWaitlist: (state, action) => {
      const newState = { ...state };
      if (action.payload.list) {
        newState.list = action.payload.list;
      }
      if (action.payload.history) {
        newState.history = action.payload.history;
      }
      return newState;
    },
    setEdit: (state, action) => {
      state.edit = action.payload;
    },
    updateEditValue: (state, action) => {
      state.edit.value = { ...state.edit.value, ...action.payload };
    },
    setDisabled: (state, action) => {
      state.disabled = action.payload;
    },
  },
});

export const loadWaitlistByMerchantId = (merchantId) => async (dispatch) => {
  const waitlist = await getWaitListByMerchantId(merchantId);
  dispatch(
    setWaitlist({
      list: waitlist.data,
    })
  );
};

export const handleWaitlistOpenStatus =
  (businessHours, isOpen, timeZone) => (dispatch) => {
    if (!isTimeInBzHours(businessHours, timeZone)) {
      dispatch(showAlert("Out of business hour."));
      dispatch(setDisabled(true));
    } else if (!isOpen) {
      dispatch(showAlert("The Waitlist is currently closed. "));
      dispatch(setDisabled(true));
    } else {
      dispatch(setDisabled(false));
    }
  };

// Action creators are generated for each case reducer function
export const { setWaitlist, setEdit, updateEditValue, setDisabled } =
  waitlistSlice.actions;
export default waitlistSlice.reducer;
